import {Injectable} from '@angular/core';
import {AuthHttpService} from '../core/auth-http.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { catchError } from 'rxjs/operators'
import moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';
import { Locations } from './locations';

@Injectable()
export class LocationsService {
  constructor(private http: AuthHttpService) {}

  list(locationCollectionId): Observable<any> {
    return this.http.getV3(`${environment.apiv3url}/locations?location_collection_id=${locationCollectionId}`).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  create(location: Locations): Observable<Locations | string> {
    return this.http.postV3<Locations>(`${environment.apiv3url}/locations`, location).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  get(id): Observable<any> {
    return this.http.getV3(`${environment.apiv3url}/locations/:id`.replace(':id', id)).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  delete(id): Observable<any> {
    return this.http.deleteV3(`${environment.apiv3url}/locations/:id`.replace(':id', id)).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  update(location: Locations): Observable<Locations | string> {
    return this.http.updateV3<Locations>(`${environment.apiv3url}/locations/:id`.replace(':id', location.id), location).pipe(
      catchError((error: HttpErrorResponse) => this.http.handleError(error)));
  }

  formatLocation(location: Locations) {
    location['created_at'] = moment(location['created_at'] as string).format('LLL');
    location['full_address'] = location.street_address + ', ' + location.city + ', ' + location.state + ' ' + location.zipcode;
  }

  formatData(locations) {
    const data = locations.locations;
    data.forEach(location => {
      this.formatLocation(location);
    });
    return data;
  }

  mutateData(location) {
    location['created_on'] = moment(location['created_at']).format('LLL');
    location['current_address'] = location.street_address + ', ' + location.city + ' ' + location.state;
    location['latitude'] = parseFloat(location.latitude).toFixed(7);
    location['longitude'] = parseFloat(location.longitude).toFixed(7);
  }
}
